import { useMemo, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { PubNubProvider } from 'pubnub-react';
import Pubnub from 'pubnub';
import { useUserStore } from '../store';
import { Loading } from '../components';
import { COOKIE_KEYS, storageKeys } from '../constants';
import { getCookies } from '../utils/cookies';
import { setCookie } from '../utils/cookies';
import { registerTrustedRecallPublisher } from '../utils/chatRecallMessage';

type Props = {
  loading?: boolean;
};

function Layout({ loading = false }: Props) {
  const { clientId, user, setClientId } = useUserStore();

  useEffect(() => {
    const storedPublisherId = localStorage.getItem(
      storageKeys.PUBNUB_SYSTEM_BACKEND_ID,
    );
    if (storedPublisherId) {
      registerTrustedRecallPublisher(storedPublisherId);
    }
  }, []);

  useEffect(() => {
    if (!clientId) {
      const existingClientId =
        getCookies(COOKIE_KEYS.CLIENT_ID) ||
        localStorage.getItem(storageKeys.CLIENT_ID) ||
        `client-${Date.now()}`;

      // Persist clientId
      setCookie([
        {
          key: COOKIE_KEYS.CLIENT_ID,
          value: existingClientId,
        },
      ]);
      localStorage.setItem(storageKeys.CLIENT_ID, existingClientId);
      setClientId(existingClientId);
    }
  }, [clientId, setClientId]);

  const pubnub = useMemo(() => {
    const uuid = user?.uuid || clientId || `client-${Date.now()}`;
    return new Pubnub({
      publishKey: process.env.REACT_APP_PUBNUB_PUBLISH_KEY || '',
      subscribeKey: process.env.REACT_APP_PUBNUB_SUBSCRIBE_KEY || '',
      uuid: uuid,
    });
  }, [clientId, user?.uuid]);

  return loading ? (
    <Loading size="md" fullScreen />
  ) : (
    <div className="h-full w-full overflow-hidden">
      {pubnub && (
        <PubNubProvider client={pubnub}>
          <Outlet />
        </PubNubProvider>
      )}
    </div>
  );
}

export default Layout;
